<script setup></script>

<template>
  <svg
    class="loader-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" stroke-opacity="0.3" />
    <path d="M21 12a9 9 0 0 0-9-9" />
  </svg>
</template>

<style scoped>
.loader-icon {
  animation: loader-icon-spin 0.8s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .loader-icon {
    animation-duration: 2.4s;
  }
}

@keyframes loader-icon-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
